module.exports = __webpack_public_path__ + "static/media/logo copy.332140b4.png";